/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_TextInputs */

const cs_builder_prop_text = /** @type {(inputs: Builder_Prop_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const en_builder_prop_text = /** @type {(inputs: Builder_Prop_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

/**
* | output |
* | --- |
* | "Text" |
*
* @param {Builder_Prop_TextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_text = /** @type {((inputs?: Builder_Prop_TextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_TextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_text(inputs)
	return cs_builder_prop_text(inputs)
});